/** Limite máximo por requisição aceito pela API de logística. */
export const MAX_API_PAGE_LIMIT = 100;

export type PaginatedQueryBase = {
  page?: number;
  limit?: number;
};

export function clampApiPageLimit(value: number): number {
  const n = Math.floor(Number.isFinite(value) ? value : 1);
  return Math.min(MAX_API_PAGE_LIMIT, Math.max(1, n));
}

export type PeriodoRange = {
  start?: string;
  end?: string;
};

/** Normaliza `limit` / `itemsPerPage` vindos do store ou de componentes legados. */
export function normalizePaginatedQuery<T extends object>(
  params: PaginatedQueryBase & T & { itemsPerPage?: number },
): PaginatedQueryBase & Omit<T, 'itemsPerPage'> {
  const { itemsPerPage, limit, page, ...rest } = params;
  return {
    ...(rest as T),
    page: page ?? 1,
    limit: clampApiPageLimit(limit ?? itemsPerPage ?? 10),
  };
}

/** Converte filtro `periodo` (date-range) em campos `*_de` / `*_ate` da API. */
export function mapPeriodoFilter<T extends Record<string, unknown>>(
  params: T,
  mapping: { periodKey?: string; startKey: string; endKey: string },
): T {
  const periodKey = mapping.periodKey ?? 'periodo';
  const periodo = params[periodKey] as PeriodoRange | undefined;
  if (!periodo) {
    return params;
  }

  const next = { ...params } as T;
  const record = next as Record<string, unknown>;
  record[mapping.startKey] = periodo.start;
  record[mapping.endKey] = periodo.end;
  delete record[periodKey];
  return next;
}

export function hasListFilters(filters: Record<string, unknown>): boolean {
  return Object.entries(filters).some(([key, value]) => {
    if (key === 'periodo' && value && typeof value === 'object') {
      const periodo = value as PeriodoRange;
      return !!(periodo.start || periodo.end);
    }
    return value !== null && value !== '';
  });
}
